
'use client';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './detailBox.scss';

const Detail = ({ label, value, copy, isInvoice, invoiceNumber, onClose }) => {
	let content;



	if (isInvoice) {
		const invoiceUrl = `/client/invoices/${invoiceNumber}`;
		content = (
			<Link to={invoiceUrl} onClick={onClose} className="sdm-link-invoice">
				{value || 'N/A'}
			</Link>
		);
	} else if (copy && value) {
		content = (
			<button onClick={() => navigator.clipboard.writeText(value)} className="sdm-copy-btn" title={`Click to copy: ${value}`}>
				{value}
			</button>
		);
	} else {
		content = <span className="sdm-value">{value || 'N/A'}</span>;
	}

	return (
		<div className="sdm-detail-row">
			<span className="sdm-label">{label}</span>
			{content}
		</div>
	);
};

const SerialDetailsModal = ({ isOpen, onClose, selectedSerial }) => {
	const [closing, setClosing] = useState(false);

	useEffect(() => {
		document.body.style.overflow = isOpen ? 'hidden' : '';
		return () => {
			document.body.style.overflow = '';
		};
	}, [isOpen]);


	const handleClose = () => {
		setClosing(true);
		setTimeout(() => {
			setClosing(false);
			onClose();
		}, 300); 
	};

	if (!isOpen || !selectedSerial) return null;

	return (
		<Modal
			show={isOpen}
			onHide={handleClose}
			backdrop={true}
			animation={false}
			size={'md'}
			dialogClassName={`sdm-wrapper ${closing ? 'closing' : ''}`}
		>
			<div className="sdm-overlay" onClick={handleClose}></div>

			<Modal.Body className="sdm-body">
				<div className="flex justify-end mb-4" style={{ paddingRight: 0 }}>
					<button className="btn modal-close-icon" onClick={onClose}>
						<svg
							id="Component_127_1"
							height="16"
							width="16"
							data-name="Component 127 – 1"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 19.295 19.289"
						>
							<path
								id="Icon_ionic-ios-close"
								data-name="Icon ionic-ios-close"
								d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z"
								transform="translate(-11.285 -11.289)"
							/>
						</svg>
					</button>
				</div>

				<div className="sdm-image-box">
					<img src={selectedSerial.thumbnail_url || '/no-image.png'} alt="Product" className="sdm-image" />
				</div>

				<h2 className="sdm-title">{selectedSerial.product_name?.match(/iPhone\s*\d+/)?.[0] || selectedSerial.product_name}</h2>
				<p className="sdm-subtitle">{selectedSerial.model}</p>

				<div className="sdm-details-section">
					<Detail label="IMEI" value={selectedSerial.imei} />
					<Detail label="Device Type" value={selectedSerial.device_type} />
					<Detail label="Memory" value={selectedSerial.memory} />
					<Detail label="Color" value={selectedSerial.colors} />
					<Detail
						label="Invoice"
						value={selectedSerial.invoice_number}
						isInvoice
						invoiceNumber={selectedSerial.invoice_number}
						onClose={handleClose}
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default SerialDetailsModal;